export const Logo = ({ light = false, size = "default" }) => (
  <span className="flex items-center" data-testid="brand-logo">
    <img
      src={light ? "/logo.png" : "/logo-dark.png"}
      alt="Casa Vacanze Margherita — From Sea to Culture"
      className={`w-auto ${size === "small" ? "h-12" : "h-16"}`}
    />
  </span>
);
